import {useTranslation} from 'react-i18next'
import {useQuery} from '@tanstack/react-query'
import {request} from '@/api/http'
import type {Asset} from '@/types/nf'
import {RefOutdatedNotice, type RefOutdatedMarker} from './RefOutdatedNotice'

export function ReferenceOutdatedList({projectId,branchId}:{projectId:string;branchId:string}) {
 const {t}=useTranslation()
 const query=useQuery({queryKey:['ref-outdated',projectId,branchId],queryFn:()=>request<Asset[]>(`/v1/projects/${encodeURIComponent(projectId)}/assets/ref-outdated?branch_id=${encodeURIComponent(branchId)}`)})
 if(query.error)return <p role="alert" className="text-sm text-destructive">{query.error.message}</p>
 if(query.isPending)return <p role="status" className="text-sm text-muted-foreground">{t('common.loading')}</p>
 if(!query.data?.length)return <p role="status" className="text-sm text-muted-foreground">{t('refOutdated.empty')}</p>
 return <div className="space-y-2">{query.data?.map(asset=>{
  let markers:RefOutdatedMarker[]=[]
  try {markers=JSON.parse(asset.payload).ref_outdated ?? []}catch{return <p key={asset.id} role="alert" className="text-sm text-destructive">{t('refOutdated.invalid')}</p>}
  return <div key={asset.id}><p className="font-mono text-xs text-muted-foreground">{asset.id}</p><RefOutdatedNotice markers={markers}/></div>
 })}</div>
}
